import * as React from "react";
import { AmericanStyle, MultiviewStyle } from "../../SecondaryHeadingContentTypes";
import { SecondaryHeadingContent } from "../../SecondaryHeadingContent";
export class RenderSubheading extends React.PureComponent {
    getContentType() {
        const HeadingContentStyles = {
            American: AmericanStyle,
            Regular: SecondaryHeadingContent,
            Multiview: MultiviewStyle
        };
        return HeadingContentStyles[this.props.cardType];
    }
    render() {
        const shouldExpand = this.props.renderedHeadings < this.props.cms.ExpandedGroupItems;
        const eventsCount = this.props.cms.ShowLeaguesEventsCount
            ? `(${this.props.eventsCountLength})`
            : "";
        const props = Object.assign(Object.assign({}, this.props), { shouldExpand, eventsCount });
        const ContentType = this.getContentType();
        return React.createElement(ContentType, Object.assign({ key: `subheading-content-${this.props.id}` }, props), this.props.children);
    }
}
//# sourceMappingURL=RenderSubheading.js.map